module.exports = __webpack_public_path__ + "img/baner-jazdy-testowe.83223fda.png";